
export const openNotification = (api, type, title, msg) => {
    api[type]({
        message: title,
        description: msg,
    });
};